import axios from 'axios';

const STORE_URL = 'https://happyboxstore.com';
const COLLECTION_HANDLE = 'build-a-happy-box';
const ADDON_PRODUCT_TYPE = 'Gift';

const actions = {
    getProducts(context) {
        axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}.json`)
        .then(response => response.data)
        .then((data) => {
        // Figure out how many pages of data we have to pull
          const numOfPages = Math.ceil(data.collection.products_count / 250);
          fetchProducts(numOfPages, []);
        })
        .catch((err) => {
          console.log('***Error Fetching NumOfProducts***');
        });

        function fetchProducts(pageNum, productList) {
            // Recursive function that gets the full list of products
            if (pageNum != 0) {
              axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}/products.json?limit=250&status=active&page=${pageNum}`)
                .then(response => response.data)
                .then((data) => {
                  const updatedProductList = [...productList, ...data.products];
                  var addonProductList = data.products.filter((product) => {
                    if (product.product_type == ADDON_PRODUCT_TYPE && product.variants.some(x => x.available)) {
                      const capacityTag = product.tags.find(tag => tag.indexOf('Capacity_') > -1);
                      if (capacityTag != undefined) {
                        const capacity = parseFloat(capacityTag.split('_')[1]);
                        product.capacity = capacity;
                      }
            
                      return product;
                    }
                  });
                  if(addonProductList.length > 0)
                    addonProductList = addonProductList.filter(x => !x.tags.includes("Shoppe_Exclusion"))
                  context.commit('setAddonProducts', addonProductList);
                  fetchProducts(pageNum - 1, updatedProductList);
                })
                .catch((err) => {
                  console.log('***Error Fetching Products***');
                });
            }
            else {
              sortFetchedProducts(productList);
            }
        }
        function sortFetchedProducts(totalProductList) {
          axios.get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
          .then(response => response.data)
          .then((data) => {
            totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
            var addonProductList = totalProductList.filter((product) => {
              if (product.product_type == ADDON_PRODUCT_TYPE && product.variants.some(x => x.inventory_quantity > 0)) {
                product.tags = product.tags.split(', ')
                const capacityTag = product.tags.find(tag => tag.indexOf('Capacity_') > -1);
                if (capacityTag != undefined) {
                  const capacity = parseFloat(capacityTag.split('_')[1]);
                  product.capacity = capacity;
                }

                product.variants = product.variants.map((variant) =>{
                  variant.available = variant.inventory_quantity > 0;
                  variant.featured_image = product.images.find(x => x.id == variant.image_id)
                  return variant
                })
      
                return product;
              }
            });
            addonProductList = addonProductList.filter(x => !x.tags.includes("Shoppe_Exclusion"))
            context.commit('setAddonProducts', addonProductList);
          })
          .catch((err) => {
            console.log(err);
            console.log('***Error Fetching NumOfProducts***');
          });
        }
    }    
};

export default actions;
